import { Box, Dialog, DialogTitle, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ICONS, Icon } from "@/modules/ui-elements/Icon";
import { useDispatch } from "react-redux";
import { endFileUpload, setFileUploadStep, startFileUpload, updateFile, updateFileUploadId, updateFileUploadProgress, updateStatus, updateStep, updateTitle, updateProjectCreate, reset, updateShowDialog } from "@/redux/reducers/file-upload.reducer";
import { useSelector } from "react-redux";
// @ts-ignore
import { STEPS, UPLOAD_STATUS, ERROR_MESSAGES } from "../../../../utils/constant";
import React, { useState } from "react";
import useToast from "@/hooks/useToast";
import { generateHash, generateUUID, getUploadProgress } from "@/utils/helpers";
import { removeUnReadNotification, updateUnReadNotification } from "@/redux/reducers/notification.reducer";
import { get, head } from "lodash";
import { uploadFile } from "src/services/file-upload";
import Loader from "@/modules/ui-elements/Loader";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "@/modules/segment-event-tracking/constant";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { segmentEventPayload, uploadAmazonListingPopupAtom } from "@/modules/editor-v2/Atoms";
import { useRouter } from "next/router";
import { createAnotherListingPopupAtom, imagesForLoadingAtom, jobGroupIdAtom, triggerJobGroupCreationAtom, uploadedImagesUrlAtom } from "@/modules/marketplaceListing/Atoms";
import { resizeAndCompressImage } from "@/utils/imageCompression";

export default function(props) {
    const [fileCount, setFileCount] = useState();
    const [loading, isLoading] = React.useState(false);
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
    const [fileUploadData, setFileUploadData] = useAtom(uploadedImagesUrlAtom);
    const setOpenCreateAnotherListingPopup = useSetAtom(createAnotherListingPopupAtom)
    const fileUploadInput = React.useRef(null);
    const fileUpload = useSelector((state:any) => state.fileUpload);
    const router = useRouter();
    const setTriggerForJobCreation = useSetAtom<any>(triggerJobGroupCreationAtom)
    const setImagesForLoading = useSetAtom<any>(imagesForLoadingAtom)
    let finalImages = []
    const setUploadAmazonListingPopup = useSetAtom(uploadAmazonListingPopupAtom);

    const dispatch = useDispatch();
    const Toast = useToast();

    const handleFileUpload = () => {
        dispatch(setFileUploadStep(STEPS.FILE_UPLOAD_STEP_2));
        dispatch(updateTitle("Files Import"));
        dispatch(updateStep(STEPS?.FILE_UPLOAD));
    };

    const onCrossClick = () => {
        setUploadAmazonListingPopup(false);
        props?.setOpenFileUploader?.(false);
        setOpenCreateAnotherListingPopup(false);
    }

    const saveProject = async () => {
        dispatch(reset());
        dispatch(updateShowDialog(false));
        dispatch(removeUnReadNotification(fileUpload.fileUploadId));
        dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE));
        if(props.onlyUploadImages) {
          onCrossClick();
          return;
        }
        router.push(`/dashboard/marketplace-listing`)
    };

    const imageUploadProgressTracker = (progressEvent, id) => {
        const progress = getUploadProgress(progressEvent);
        dispatch(updateFileUploadProgress({ id: id, progress: progress }));
    };

    const saveFileToS3 = async (file) => {
        const id = generateHash(get(file, "name", ""));
        try {
          dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOADING));
          dispatch(
            startFileUpload({
              id: id,
            })
          );
    
          const options = {
            onUploadProgress: (progressEvent) => {
              imageUploadProgressTracker(progressEvent, id);
            },
          };
          const response = await uploadFile(file, options);
          if (get(response, "data.success", false)) {
            const imageUrl = head(get(response, "data.images", []));
            finalImages.push(imageUrl)
            dispatch(
              endFileUpload({
                id: id,
                imageUrl: imageUrl,
              })
            );
            // const updatedList = failedImagesHandler.remove(id);
            // if (updatedList.length === 0) {
            //   dispatch(
            //     updateUnReadNotification({
            //       id: fileUpload.fileUploadId,
            //       progress: 101,
            //       createdAt: new Date(),
            //       errorDescription: "File upload completed",
            //       error: false,
            //     })
            //   );
            // }
            return true;
          }
          return false;
        } catch (error) {
        //   failedImagesHandler.add({ id: id, file: file });
          dispatch(updateFile({ id: id, failed: true }));
          dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_FAILED));
          dispatch(updateFileUploadProgress({ id: id, progress: 100 }));
        }
      };

    const onFileSelect = async (e) => {
        TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_upload_image_list}`,{
            ...getSegmentPayloadAtom,
            marketplace_name:'Amazon',
        });
        // CHECK IF ANY EXTERNAL EXTENSION OF IMAGE IS GETTING SELECTED - IF YES THROW ERROR
        const uploadedFiles = e.target.files;
        let isExternalImageExtension = false;
        Array.from(uploadedFiles)?.forEach((item:any)=> {
          if(item.name?.endsWith('.png') 
              || item.name?.endsWith('.jpeg') 
              || item.name?.endsWith('.PNG') 
              || item.name?.endsWith('JPEG') 
              || item.name?.endsWith('jpg') 
              || item.name?.endsWith('JPG')
              || item.name?.endsWith('.webp')
            ){
            isExternalImageExtension = false;
          }else{
            isExternalImageExtension =true;
          }
        })
        if(isExternalImageExtension) {
          return Toast.error('Please select image!')
        }
        try {
          let filesSelected = e.target.files;
          if(filesSelected.length > 5)
          {
            Toast.error("Select only upto 5 images")
            return;
          }
          setFileCount(filesSelected.length)
          isLoading(true)
          dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOADING));
          // generating file id for notification
          let id = fileUpload?.fileUploadId;
          if (!fileUpload.fileUploadId) {
            id = generateUUID();
            dispatch(updateFileUploadId(id));
          }
          let progressBuffer = Math.round(100 / filesSelected.length, 2);
          let updatedProgress = progressBuffer;
          let count = 0;
          dispatch(
            updateUnReadNotification({
              id: id,
              progress: updatedProgress,
              createdAt: new Date(),
            })
          );
          for (let file in filesSelected) {
            if (filesSelected.hasOwnProperty(file)) {
              let compressedFile = await resizeAndCompressImage(filesSelected[file])
              const fileUploaded = await saveFileToS3(compressedFile);
              updatedProgress += progressBuffer;
              dispatch(
                updateUnReadNotification({
                  id: id,
                  progress: updatedProgress,
                  createdAt: new Date(),
                  error: false,
                })
              );
              if (fileUploaded) {
                count++;
              }
            }
          }
          if (count === filesSelected.length) {
            isLoading(false);
            dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_DONE));
            setFileUploadData(finalImages)
            setTriggerForJobCreation({images:finalImages, marketplace_id:"64cb7e5423d9644b4cf689e2"})
            setImagesForLoading({images:finalImages})
            await saveProject();
          } else {
            // finalImages = [];
            dispatch(
              updateUnReadNotification({
                id: id,
                progress: 101,
                createdAt: new Date(),
                errorDescription: "Project creation faild",
                error: true,
              })
            );
            dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_FAILED));
          }
        } catch (error) {
          dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_FAILED));
          console.error("Error---", error);
          Toast.error(error)
          isLoading(false);
        }
      };

    return (
        <Dialog 
            open={props?.openFileUploader} 
            maxWidth="xl"
            aria-labelledby="customized-dialog-title"
            PaperProps={{
                sx: { backgroundColor: "white", margin: 0, width: "610px" ,"::-webkit-scrollbar": {
                  display:"none"
              }},
            }}
            BackdropProps={{ style: { opacity: 1 } }}
        >
            <DialogTitle
                sx={{
                    m: 0,
                    p: 2,
                    borderBottom: "1px solid #EEEEEE",
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'space-between',
                    alignContent: 'center'
                }}
                onClick={onCrossClick}
            >
                <Typography variant="h6">{props?.title}</Typography>
                <CloseIcon sx={{cursor:'pointer',}} />
            </DialogTitle>
            {
                loading 
                ? (
                    <div style={{height:300, width:500, alignSelf:'center'}}>
                        <Loader height={40} width={40}/>
                        Uploading File...
                    </div> 
                )
                : (
                    <div style={{display:"flex",flexDirection:"column",gap:"16px",padding:"16px"}}>
                        <Box sx={{fontSize:"12px",lineHeight:"20px"}}>{props?.webListingScreen?.ListingModalSubtitle || 'Upload your product photos'}</Box>
                        <Box sx={{fontSize:"12px",lineHeight:"20px"}}>{props?.webListingScreen?.ListingFormats || '*File formats supported - JPEG, PNG, WEBP'}</Box>
                        {/* FILE UPLOAD */}
                        <Box        
                            onClick={handleFileUpload}
                            justifyContent="space-between"
                            sx={{
                                border: "1px solid rgba(238, 238, 238, 1)",
                                borderRadius: "4px",
                                p:"16px",
                                background: "#F9F9F9",
                                ":hover":{
                                    border:"1px solid #262626"
                                },
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor:'pointer',
                            }}
                        >
                            <Icon src={ICONS.uploadDark} height={24} width={24} />
                            <input
                                ref={fileUploadInput}
                                    disabled={
                                        fileUpload.status === UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS
                                    }
                                    // @ts-expect-error
                                    webkitdirectory
                                    multiple={props.multiple}
                                    style={{
                                        opacity: 0,
                                        width:'93%',
                                        position:'absolute',
                                        top:150,
                                        height:'23%',
                                        zIndex: 100,
                                        left:20,
                                        cursor: "pointer"
                                    }}
                                    type="file"
                                    accept=".jpeg,
                                    .jpg,
                                    .png,
                                    .pdf,
                                    .JPEG,
                                    .JPG,
                                    .PNG,
                                    .webp,"
                                    onChange={onFileSelect}
                            />
                            <Typography sx={{textAlign: 'center', fontSize: "14px", marginTop: '8px'}}>{props?.webListingScreen?.SelectFromDevice || 'Select from your device'}</Typography>
                        </Box>
                        {/* SELECT EXISTING PROJECTS */}
                        {
                          !props.hideExistingProjects && <Box        
                              onClick={props?.handleUploadExistingProject}
                              justifyContent="space-between"
                              sx={{
                                  border: "1px solid rgba(238, 238, 238, 1)",
                                  borderRadius: "4px",
                                  p:"16px",
                                  background: "#F9F9F9",
                                  ":hover":{
                                      border:"1px solid #262626"
                                  },
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor:'pointer',
                              }}
                          >
                              <Icon src={ICONS.myWorkDark} height={24} width={24} />
                              <Typography sx={{textAlign: 'center', fontSize: "14px", marginTop: '8px'}}>{props?.webListingScreen?.SelectFromExisting || 'Select from existing projects'}</Typography>
                          </Box>
                        }
                    </div>
                )
            }
        </Dialog>
    )
}